export default __webpack_public_path__ + "static/image 2-dea5aedb3745d773625596c488474bab.png";